import {loadAssetWithCache} from './assetCache';

export interface LoadFormParams {
    cssUrl: string;
    jsUrl: string;
    pageTitle?: string;
    bootstrapOnly: boolean;
}

const loadCss = async (url: string): Promise<void> => {
    return loadAssetWithCache(url, () => new Promise<void>((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;

        link.onload = () => resolve();
        link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));
        document.head.appendChild(link);
    }));
};

const loadJs = async (url: string): Promise<void> => {
    return loadAssetWithCache(url, () => new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
        document.head.appendChild(script);
    }));
};

export async function mountForm(params: LoadFormParams): Promise<void> {
    const cssUrl = !params.bootstrapOnly
        ? params.cssUrl
        : params.cssUrl.replace('form.css', 'form.bootstrap.css');
    const jsUrl = !params.bootstrapOnly
        ? params.jsUrl
        : params.jsUrl.replace('form.js', 'form.bootstrap.js');

    if (params.pageTitle !== undefined) {
        document.title = params.pageTitle;
    }
    // load css / js
    await Promise.all([
        loadCss(cssUrl),
        loadJs(jsUrl)
    ]);
}
